import { Autocomplete, Button, Card, Dialog, DialogContent, DialogTitle, Divider, Grid, IconButton, Slide, TextField } from "@mui/material";
import { IconCircleX } from "@tabler/icons-react";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { removeEmptyKeys } from "helper/encodeData";
import React, { forwardRef, useEffect, useState, } from "react";
import { connect } from "react-redux";
import { setRegionFilteredData } from "store/app/form-management/region-configuration/actions";

const regionStatusOption = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
]

const Transition = forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);

const FilterRegion = (props) => {

    const { open, onClose, regionFilterData } = props;

    const [isAutoOpenRegionStatus, setIsAutoOpenRegionStatus] = useState();
    const [filter, setFilter] = useState();

    useEffect(() => {
        if (regionFilterData) {
            setFilter(regionFilterData);
        }
        else {
            setFilter(null);
        }
    }, [open]);

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        setFilter({
            ...filter,
            [name]: value,
        });
    }
    const handleSelect = (e, option, name) => {
        const { label } = option || {};
        setFilter({
            ...filter,
            [name]: label,
        });
    }
    const handleFilter = (e) => {
        e.preventDefault();
        onClose();
        const nonEmptyData = removeEmptyKeys(filter);
        props.setRegionFilteredData(nonEmptyData);
    }

    const handleFilterClear = (e) => {
        e.preventDefault();
        onClose();
        props.setRegionFilteredData();
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                maxWidth={'md'}
                fullWidth
                keepMounted
                onClose={validateClose}
                sx={{
                    '&>div:nth-of-type(3)': {
                        justifyContent: 'flex-end',
                        '&>div': {
                            m: 0,
                            borderRadius: '10px 0px 0px 10px',
                            maxWidth: 450,
                            maxHeight: '100%'
                        }
                    }
                }}
            >
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Filters
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={4} direction="column">
                                            <Grid item>
                                                <TextField
                                                    autoFocus
                                                    label="Region Name"
                                                    fullWidth
                                                    size="small"
                                                    name='regionname'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={filter?.regionname}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <Autocomplete
                                                    size="small"
                                                    disablePortal
                                                    options={regionStatusOption}
                                                    open={isAutoOpenRegionStatus}
                                                    onOpen={() => setIsAutoOpenRegionStatus(true)}
                                                    onClose={() => setIsAutoOpenRegionStatus(false)}
                                                    onChange={(e, option) => handleSelect(e, option, 'regionstatus')}
                                                    value={filter?.regionstatus}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            label="Region Status"
                                                        />
                                                    }
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilter}
                                                size="small"
                                                color="primary"
                                                startIcon={<IconAdjustmentsHorizontal />}
                                            >
                                                Apply Filters
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={handleFilterClear}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                                startIcon={<IconCircleX />}
                                            >
                                                Clear
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    regionFilterData: state.regions.regionFilterData,
})
const mapDispatchToProps = (dispatch) => ({
    setRegionFilteredData: (filter) => dispatch(setRegionFilteredData(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterRegion);